import React from "react";
import MyPromotionList from "@/MyPromotionTabs/List";
import useFetchAppliedHistory from "@/MyPromotionTabs/hooks/useFetchAppliedHistory";

const Completed = () => {
    const { promotions, loading, dateRange, setDateRange } = useFetchAppliedHistory(
        "completed",
        true
    );

    return (
        <MyPromotionList
            promotions={promotions}
            loading={loading}
            type="completed"
            onCardActionClick={() => {}}
            showTabs={true}
            showDatePicker={true}
            dateRange={dateRange}
            onDateChange={setDateRange}
        />
    );
};

export default Completed;
